(function() {
    'use strict';

    angular
        .module('teJHipsterApp')
        .controller('HandbookNodeDeleteController',HandbookNodeDeleteController);

    HandbookNodeDeleteController.$inject = ['$uibModalInstance', 'entity', 'HandbookNode'];

    function HandbookNodeDeleteController($uibModalInstance, entity, HandbookNode) {
        var vm = this;

        vm.handbookNode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HandbookNode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
